<template>
  <div class="card-body mt-5 bg-white shadow-sm" style="border-radius: 10px;">
    <form
        v-if="status === 'success'"
        class="kt-form col-12 col-md-7 mx-auto border border-success shadow-lg py-5 m-5"
        @submit.prevent="action($event, query)"
        style="border-radius: 20px"
    >
      <div class="text-center">تیکت جدید</div>
      <hr style="background-color: #797676">
      <div class="p-4 py-1">

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>دسته بندی</label>
              <select
                  id="category_id"
                  class="form-control kt-selectpicker"
                  name="category_id"
                  v-model="query.category_id"
              >
                <option
                    v-bind:key="index"
                    v-for="(category, index) in categories"
                    v-bind:value="category.id"
                    class=""
                >
                  {{ category.label }}
                </option>
              </select>
              <span class="mt-4 py-2 text-wrap badge badge-danger"> جهت تسریع در پاسخگویی، لطفا دسته بندی را با دقت انتخاب نمایید. </span>
            </div>
          </div>

<!--          <div class="col-lg-6 col-12">-->
<!--            <div class="form-group">-->
<!--              <label>اولویت</label>-->
<!--              <select id="priority" class="form-control kt-selectpicker" name="priority" v-model="query.priority">-->
<!--                <option-->
<!--                    v-bind:key="index"-->
<!--                    v-for="(priority, index) in priorities"-->
<!--                    v-bind:value="priority.value"-->
<!--                    :selected="index == 1"-->
<!--                >-->
<!--                  {{ priority.name }}-->
<!--                </option>-->
<!--              </select>-->
<!--            </div>-->
<!--          </div>-->
        </div>


        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>عنوان</label>
              <input class="form-control"
                     v-model="query.subject"
                     id="subject"
                     name="subject"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>توضیحات</label>
              <textarea
                  rows="5"
                  v-model="query.content"
                  id="content"
                  name="content"
                  class="form-control"></textarea>
            </div>
          </div>
        </div>


        <div class="form-group ">
          <kt-form-group class="mt-3">
            <kt-form-label>
              {{ $t('label.file_attaching') }}
            </kt-form-label>
            <kt-form-label for="file" class="d-block btn btn-secondary btn-wide label-file">
              <kt-icon type="fa" name="paperclip"></kt-icon>
              {{ $t('label.select_file') }}
            </kt-form-label>
            <input
                @change="processFile"
                type="file"
                class="custom-file-upload"
                name="file"
                id="file"
                accept="image/png,.jpg,.jpeg,.zip"
            />
          </kt-form-group>
          <div class="custom-alert position-relative z-index-low mb-3">
            <div class="my-2 text-secondery" role="alert">
              <div>
                فرمت های مجاز فایل ضمیمه شامل
                فرمتهای مجاز فایل <b>zip, jpeg, png, jpg </b>می‌باشد.
              </div>
            </div>
          </div>
        </div>
        <hr class="my-4">
        <button class="btn btn-success float-left" type="submit" id="submit_button">
          {{ $t('btn.submit') }}
        </button>
      </div>
    </form>
    <form v-else class="kt-form" style="filter: blur(10px);">
      <div class="d-flex">
        <div class="px-4 ml-auto">تیکت جدید</div>
      </div>
      <hr>
      <div class="p-4 py-5">

        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>دسته بندی</label>
              <select class="form-control" name="category_id">
              </select>
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <label>اولویت</label>
              <select class="form-control" name="priority">
              </select>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>موضوع</label>
              <input class="form-control"
                     name="subject"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>توضیحات</label>
              <textarea
                  rows="5"
                  name="content"
                  class="form-control"></textarea>
            </div>
          </div>
        </div>


        <div class="form-group ">
          <kt-form-group class="mt-3">
            <kt-form-label>
              {{ $t('label.file_attaching') }}
            </kt-form-label>
            <kt-form-label for="file" class="d-block btn btn-secondary btn-wide label-file">
              <kt-icon type="fa" name="paperclip"></kt-icon>
              {{ $t('label.select_file') }}
            </kt-form-label>
            <input
                type="file"
                class="custom-file-upload"
                name="file"
                accept="image/png,.jpg,.jpeg,.zip"
            />
          </kt-form-group>
          <div class="custom-alert position-relative z-index-low mb-3">
            <div class="my-2 text-secondery" role="alert">
              <div>
                فرمت های مجاز فایل ضمیمه شامل
                فرمتهای مجاز فایل <b>zip, jpeg, png, jpg </b>می‌باشد.
              </div>
            </div>
          </div>
        </div>
        <hr class="my-3">
        <button class="btn btn-success float-left" type="submit" >
          {{ $t('btn.submit') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import $ from "jquery";
import {i18n} from "@/plugins/i18n";

export default {
  name: "CreateForm",
  props: {
    action: {
      default: function(e, query) {},
      required: true,
    },
  },
  data() {
    return {
      query: {
        category_id: null,
        priority: '2',
      },
      categories: [],
      category: {
        children: []
      },
    }
  },
  computed: {
    ...mapGetters('user', [
      'usersSelectable',
      'usersListStatus',
    ]),
    ...mapState('ticket', {
      status: state => state.status,
    }),
    userId() {
      return this.$route.params.hashid
    },
    priorities() {
      return [
        {
          name: this.$t('ticket.priority.low'),
          value: '0',
        },
        {
          name: this.$t('ticket.priority.middle'),
          value: '1',
        },
        {
          name: this.$t('ticket.priority.high'),
          value: '2',
        },
      ]
    }
  },
  watch: {
    status() {
      this.categories = this.$store.state.ticket.categories
      this.afterDispatch()
    },
  },
  methods: {
    ...mapActions('ticket', {
      fetchCategories: 'fetchCategories'
    }),
    actionM(event, query) {
      this.action(event, query)

    },
    afterDispatch() {
      setTimeout(function () {
        $('.kt-selectpicker').selectpicker({
          size: 4,
          liveSearch: true,
          noneResultsText: i18n.t('selectpicker.none_result'),
          selectAllText: i18n.t('selectpicker.select_all'),
          noneSelectedText: i18n.t('selectpicker.nothing_selected')
        })
      }, 500)
    },
    ShowUserSelectOption(can_manage_ticket) {
      if (this.userId == undefined && can_manage_ticket) {
        return true;
      }
      else {
        return false;
      }

    },
    processFile(e) {
      this.query.file = event.target.files[0]
      let size_validation = this.validateSize(event.target)
      if (size_validation)
        this.validateFormat(event.target)
    },
    validateSize(file) {
      var FileSize = file.files[0].size / 1024 / 1024; // in MB
      if (FileSize > 1) {
        alert(i18n.t('label.comment_files_allowed_size'));
        $('#file').val('')
        this.query.file = ''
        $(file).val('');
        return false;
      } else {
        return true;
      }
    },
    validateFormat(file) {
      let jq_file = $(file);
      let file_name = jq_file.val();
      let extension = file_name.replace(/^.*\./, '');
      if (extension === file_name) {
        extension = '';
      } else {
        extension = extension.toLowerCase();
      }

      switch (extension) {
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'zip':
          break;
        default:
          alert(i18n.t('authenticate.input_format_err'));
          $('#file').val('')
          this.query.file = ''
          $(file).val('');
      }
    }
  },
  mounted() {
    this.fetchCategories()
  }
}
</script>

<style scoped>

</style>